import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  getKitchenStations,
  getMenuItemsAll
} from '../../services/api';
import api from '../../services/api';
import './KitchenSettings.css';

const KitchenSettings = () => {
  const { restaurantId } = useParams();
  const { t } = useTranslation();
  const [stations, setStations] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [newColor, setNewColor] = useState('#10B981');

  const fetchData = async () => {
    setLoading(true);
    try {
      const [stationsRes, menuRes] = await Promise.all([
        getKitchenStations(restaurantId),
        getMenuItemsAll(restaurantId)
      ]);
      setStations(stationsRes.data?.stations || []);
      setMenuItems(Array.isArray(menuRes.data) ? menuRes.data : []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [restaurantId]);

  const handleCreateStation = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    setCreating(true);
    try {
      await api.post('/kitchen/stations', {
        restaurantId: parseInt(restaurantId, 10),
        name: newName.trim(),
        color_hex: newColor
      });
      setNewName('');
      setNewColor('#10B981');
      fetchData();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  if (loading) {
    return (
      <div className="kitchen-settings">
        <div className="kitchen-settings__loading">{t('common.loading')}</div>
      </div>
    );
  }

  return (
    <div className="kitchen-settings">
      <div className="kitchen-settings__header">
        <h1>{t('kitchen.settingsTitle')}</h1>
        <Link to={`/kitchen/${restaurantId}`} className="kitchen-settings__link">
          {t('kitchen.openDisplay')}
        </Link>
      </div>

      <section className="kitchen-settings__section">
        <h2>{t('kitchen.stationsSection')}</h2>
        <p className="kitchen-settings__hint">
          {t('kitchen.stationsHint')}
        </p>
        <ul className="kitchen-settings__list">
          {stations.map((s) => (
            <li key={s.id} className="kitchen-settings__station">
              <span
                className="kitchen-settings__station-color"
                style={{ backgroundColor: s.color_hex || '#10B981' }}
              />
              <span className="kitchen-settings__station-name">{s.name}</span>
            </li>
          ))}
        </ul>
        <form onSubmit={handleCreateStation} className="kitchen-settings__form">
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            placeholder={t('kitchen.stationNamePlaceholder')}
            className="kitchen-settings__input"
            disabled={creating}
          />
          <input
            type="color"
            value={newColor}
            onChange={(e) => setNewColor(e.target.value)}
            className="kitchen-settings__color"
            title={t('kitchen.color')}
          />
          <button type="submit" className="btn btn-primary" disabled={creating}>
            {creating ? t('kitchen.adding') : t('kitchen.addStation')}
          </button>
        </form>
      </section>

      <p className="kitchen-settings__footer">
        {t('kitchen.footerHint', { count: menuItems.length })}
      </p>
    </div>
  );
};

export default KitchenSettings;
